import React, { useEffect, useState } from 'react';
import { Card, Form, Button, ListGroup, Modal } from 'react-bootstrap';
import { ArrowLeft } from 'react-bootstrap-icons';

const B2BTab = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [b2bUsers, setB2bUsers] = useState([]);
  const [selectedB2B, setSelectedB2B] = useState(null);

  useEffect(() => {
    fetchB2BUsers();
  }, []);

  const fetchB2BUsers = async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/b2b-users`);
      const data = await res.json();
      setB2bUsers(data);
    } catch (err) {
      console.error('Failed to fetch B2B users', err);
    }
  };

  const handleB2BClick = async (userId) => {
    try {
      const res = await fetch(`${API_URL}/api/admin/b2b-users/${userId}`);
      const data = await res.json();
      setSelectedB2B(data);
    } catch (err) {
      console.error('Error fetching B2B user details:', err);
    }
  };

  return (
    <div>
      <h4 className="mb-3">B2B Users</h4>
      {!selectedB2B ? (
        <ListGroup>
          {b2bUsers.map((user) => (
            <ListGroup.Item key={user._id} action onClick={() => handleB2BClick(user._id)}>
              <strong>{`${user.first_name} ${user.last_name}`}</strong> — {user.company_name}
            </ListGroup.Item>
          ))}
        </ListGroup>
      ) : (
        <Card className="p-4 shadow-sm">
          <Button variant="link" onClick={() => setSelectedB2B(null)} className="mb-3">
            <ArrowLeft /> Back to List
          </Button>
          <h5>{`${selectedB2B.first_name} ${selectedB2B.last_name}`}</h5>
          <p><strong>Company:</strong> {selectedB2B.company_name}</p>
          <p><strong>Email:</strong> {selectedB2B.email}</p>
          <p><strong>Phone:</strong> {selectedB2B.phone}</p>
          <p><strong>Country:</strong> {selectedB2B.country}</p>
          <p><strong>Gender:</strong> {selectedB2B.gender}</p>
          {/* <p><strong>Skills:</strong> {Array.isArray(selectedB2B.skills) ? selectedB2B.skills.join(', ') : selectedB2B.skills}</p> */}

          {/* <h6 className="mt-4">Qualifications</h6>
          <ul>
            {selectedB2B.qualification?.map((q, idx) => (
              <li key={idx}>{q.course} from {q.university} ({q.year})</li>
            ))}
          </ul>

          <h6>Experience</h6>
          <ul>
            {selectedB2B.experience?.map((e, idx) => (
              <li key={idx}>{e.role} at {e.company} ({e.from} - {e.to})</li>
            ))}
          </ul> */}

          {/* {selectedB2B.cv && (
            <>
              <h6 className="mt-4">CV Preview</h6>
              <embed
                src={`data:${selectedB2B.cv.contentType};base64,${selectedB2B.cv.data}`}
                type="application/pdf"
                width="100%"
                height="400px"
              />
            </>
          )}

          {selectedB2B.certificate && (
            <>
              <h6 className="mt-4">Certificate Preview</h6>
              <embed
                src={`data:${selectedB2B.certificate.contentType};base64,${selectedB2B.certificate.data}`}
                type="application/pdf"
                width="100%"
                height="400px"
              />
            </>
          )} */}
        </Card>
      )}
    </div>
  );
};

export default B2BTab;
